export const GroupTypes = {
    PROJECT_MANAGER : 'Project Manager',
    BILLING_RESPONSIBLE : 'Billing',
    PARTNER_COORDINATOR : 'Partner/Coördinator',
    BYPASS_MAINTENANCEMODE : 'BypassMaintenanceMode'
};
